import React from "react";
import { Box, Button, Typography } from "@mui/material";
import logo from "../../assets/images/inventory.png";
import { useTheme } from "@mui/material/styles";
import { lightTheme, useStyles } from "../../assets/styles/Theme";
import PrintIcon from "@mui/icons-material/Print";
import { ThemeProvider } from "@mui/material/styles";

function GrnPdfHeader({ docType, grnHeader, handlePrint, grnCompany }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const companyName = grnCompany?.compname || "";
  const address1 = grnCompany?.compaddresS1 || "";
  const address2 = grnCompany?.compaddresS2 || "";
  const address3 = grnCompany?.compaddresS3 || "";
  const city = grnCompany?.city || "";
  const province = grnCompany?.province || "";
  const country = grnCompany?.country || "";
  const fullAddress = [address1, address2, address3, city, province, country]
    .filter(Boolean)
    .join(", ");

  const contact = grnCompany?.hotline || "-";
  const email = grnCompany?.email || "-";
  const website = grnCompany?.website || "-";
  const vat = grnHeader?.vatno || "N/A";
  const logoSrc =
    grnCompany?.logopath && grnCompany.logopath !== "-"
      ? grnCompany.logopath
      : logo;

  return (
    <>
      <ThemeProvider theme={lightTheme}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mb: 2,
          }}
        >
          {/* <Button
          variant="outlined"
          size="small"
          className="no-print"
          onClick={() => window.print()}
        >
          Download
        </Button> */}
          <Button
            variant="contained"
            size="small"
            className="no-print"
            onClick={handlePrint}
            startIcon={<PrintIcon />}
            sx={styles.btn_primary}
          >
            Print
          </Button>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Box
            sx={{
              textAlign: "left",
              // flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              component="img"
              src={logoSrc}
              alt={`${companyName} Logo`}
              sx={{ width: 144, height: 80, objectFit: "contain" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = logo; // fallback to local logo on error
              }}
            />

            <Box
              component="span"
              sx={{
                border: "1px solid #0F61AC",
                px: 3,
                py: 0.5,
                mt: 1,
                // display: "inline-block",
                color: "#0F61AC",
                fontSize: theme.typography.subtitle_s,

                cursor: "default",
                userSelect: "none",
              }}
            >
              {docType}
            </Box>
          </Box>
          <Box
            sx={{
              textAlign: "right",
              flex: 1,

              color: "black",
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              color="#0F61AC"
              sx={{
                //  fontFamily: "serif",
                mb: 0.5,
              }}
            >
              {companyName}
            </Typography>
            <Typography
              sx={{
                fontSize: theme.typography.subtitle_xs,
              }}
            >
              {fullAddress}
              <br />
              {contact}
              <br />
              {email}
              <br />
              {website}
              <br />
              VAT Reg No:{vat}
            </Typography>
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
}

export default GrnPdfHeader;
